// Helpers para destacar el/los producto(s) usados en la última generación
// exitosa. Se persisten como array de ids en localStorage bajo
// 'atlas-v2-last-products' (lo escribe InterfazV2 al confirmar). Los menús
// de "Elegir de mis productos" les ponen el badge "Último utilizado".
//
// Ordenar por uso YA NO se hace acá: el orden "Últimos utilizados" del toolbar
// de los catálogos usa `lastUsedAt` (derivado de `imagenes_generadas`, ver
// `productsApi.fetchProductLastUsedMap`), que cubre todo el historial y no solo
// la última generación. Esto queda solo para el badge.

const LAST_USED_KEY = 'atlas-v2-last-products';

export function getLastUsedProductIds(): string[] {
  try {
    const raw = localStorage.getItem(LAST_USED_KEY);
    if (!raw) return [];
    const ids = JSON.parse(raw);
    return Array.isArray(ids) ? ids.map((id) => String(id)) : [];
  } catch {
    return [];
  }
}
